export default "/_next/static/node_modules/@riotgames/blades-ui/dist/skins/common/assets/square.svg";